import RestClient from "../common/RestClient";
import { RestService } from "./RestService";

export class AuthService extends RestService {
  constructor() {
    super(`api/v1/auth`);
  }
}
